import { colors, Grid, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { ISaveResponse } from '../../NewRegistrationContext';
import { Label } from 'components';


interface IProps {
    response: ISaveResponse
}

let Summary = ({ response }: IProps) => {
    return (
        <>
            <Typography variant="h4" gutterBottom>Warranty Extension Completed</Typography>
            <Label color={colors.green[500]} shape="square" variant="contained">
                Warranty Expiration:&nbsp;
                {response.unlimited && 'Unlimited warranty'}
                {response.unlimited === false &&
                    <><Moment date={response.warrantyExpirationDate} format="ll" />&nbsp;-&nbsp;{response.warrantyExtensionMonths}&nbsp;months</>
                }
            </Label>

            <Grid container style={{ marginTop: 20 }}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom>
                        <strong dangerouslySetInnerHTML={{ __html: response.warrantyTitle['en-GB'] }}></strong>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom dangerouslySetInnerHTML={{ __html: response.warrantyDescription['en-GB'] }}></Typography>
                </Grid>
            </Grid>
        </>
    )
}

export default Summary;